// Translation Dependencies
import { getModel } from '../../model/registry'
import { useSnapshot } from 'valtio';
import useTranslation from '../../hooks/useTranslation';
import  {useModalStack } from '../../context/modalStackContext';
import languages from '../../model/languages'

//Import the useClick Outside & the Switcher
import { Switcher } from '../generic/Switcher';

//Import the popUp things I need
import { PopUp } from '../modal/PopUp';

function LangSwitcher() {
  const { t, tState } = useTranslation()
  const { pushModal } = useModalStack();
  const snap = useSnapshot(tState)

  let config = getModel('modalDialogData')['langSwitch']


  //TEMPORARY FIX
  const language = snap.currentLang

  //This is the function run by selecting an option on Switcher
  const handleSelect = (option) => {
    //Changing the Language
    tState.currentLang = option.id
    localStorage.setItem('language', option.id)
    //Passing the Language to the PopUp and showing the PopUp
    const updatedConfig = { ...config };
    updatedConfig.params = [...(config.params || [])];
    updatedConfig.params[0] = t(`LanguageSwitcher.${option.id}`);
    pushModal(PopUp, { config: updatedConfig });
  }

  const options = languages
    .filter(lang => lang !== language)
    .map(lang => ({ type: 'item', id: lang, name: t(`LanguageSwitcher.${lang}`) }))

  return (
    <Switcher
      type='lang'
      currentOption={t(`LanguageSwitcher.short.${language}`)}
      options={options}
      handleSelect={handleSelect}
    />
  )


}

export default LangSwitcher
